import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { reporteVentas } from "../../../../service/cortesias/cortesias";
import { ReporteVentasModel, VentasProductosModel } from "../models/ReporteVentasModel";

export const useReporteVentas = (realoadGrid: number, id_dia: number, id_caja: number, nombreProducto: string) => {

  const [list, setList] = useState<VentasProductosModel[]>([]);
  const [ingresos, setIngresos] = useState<ReporteVentasModel>({
    ingreso_efectivo: 0,
    ingreso_tarjeta: 0,
  });
  const [loadingRequest, setLoadingRequest] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await reporteVentas(id_dia, id_caja, nombreProducto)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setList(res.ventas_producto);
        setIngresos(res);
        setLoadingRequest(false);
      }
    };
    // if(id_dia > 0 || id_caja > 0){
    //   fetchPost();
    // }else{
    //   setLoadingRequest(false);
    //   setList([]);
    // }
    fetchPost();

  }, [realoadGrid, id_dia, id_caja, nombreProducto]);

  return { list, ingresos, loadingRequest };
};
